import { render, staticRenderFns } from "./recordDetails.vue?vue&type=template&id=256b0086&"
import script from "./recordDetails.vue?vue&type=script&lang=js&"
export * from "./recordDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports